import { createSlice, configureStore, createAsyncThunk } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';

// 创建子模块
const User = createSlice({
    name: 'user',
    // 初始状态
    initialState: {
        user: ["首页"],
        loading: false,
        theme: true,
    },
    // 整合器
    reducers: {
        setBreadcrumb: (state, action) => {
            state.user = action.payload
        },
        loadingTrue: (state, action) => {
            state.loading = true
        },
        loadingFalse: (state, action) => {
            state.loading = false
        },
        themeFalag: (state, action) => {
            state.theme = !state.theme
        },
    }
})

// 异步
const UserQuery = createAsyncThunk(
    "user/query",
    async () => {
        const data = await data
    }
)

export const { setBreadcrumb, loadingTrue, loadingFalse, themeFalag } = User.actions;

// Redux Persist 配置
const persistConfig = {
    key: 'root',
    storage: storage,
    whitelist: ['theme'], // 指定要持久化的状态字段
};

// 创建持久化的Reducer
const persistedReducer = persistReducer(persistConfig, User.reducer);

// 创建 store 
const store = configureStore({
    reducer: {
        breadcrumb: persistedReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REGISTER', 'persist/REHYDRATE'], // 忽略 persist 相关 action
            },
        }),
})

export default store;